/**
 * RETOBLOCK VARIABLE & LIST MODAL
 * Giao diện Popup tạo Biến số & Danh sách dữ liệu chuẩn phong cách LEGO SPIKE Prime & Scratch 3.0.
 * Thay thế hoàn toàn hộp thoại prompt() mặc định của trình duyệt với trải nghiệm trực quan, tiếng Việt 100%.
 */

export class VariableModal {
  constructor(options = {}) {
    this.container = options.container || document.body;
    this.onConfirm = options.onConfirm || null;

    this.currentType = 'variable'; // 'variable' | 'list'
    this.init();
  }

  init() {
    this.container.innerHTML = `
      <div class="modal-overlay" id="variable-modal-overlay">
        <div class="modal-card variable-dialog-modal">
          <div class="modal-header variable-modal-header">
            <div class="modal-title">
              <span class="variable-modal-badge" id="variable-modal-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path d="M4 7V4h16v3M9 20h6M12 4v16"/>
                </svg>
              </span>
              <span id="variable-modal-title">Tạo Biến Số Mới</span>
            </div>
            <button class="btn-close-modal" id="btn-close-variable-modal" title="Đóng">&times;</button>
          </div>

          <div class="modal-body variable-modal-body">
            <label class="variable-input-label" id="variable-input-label" for="variable-name-input">Tên biến số mới:</label>
            <input
              type="text"
              class="variable-text-input"
              id="variable-name-input"
              placeholder="Ví dụ: diem_so, van_toc, buoc_dem..."
              maxlength="40"
              autocomplete="off"
            />
            <div class="variable-modal-error" id="variable-modal-error" style="display: none;"></div>
            <div class="variable-modal-hint" id="variable-modal-hint">
              Biến số dùng chung cho toàn bộ kịch bản điều khiển robot.
            </div>
          </div>

          <div class="modal-footer variable-modal-footer">
            <button type="button" class="btn-secondary-modal" id="btn-cancel-variable">HỦY</button>
            <button type="button" class="btn-confirm-variable" id="btn-save-variable">LƯU</button>
          </div>
        </div>
      </div>
    `;

    this.bindEvents();
  }

  bindEvents() {
    this.overlay = document.getElementById('variable-modal-overlay');
    this.input = document.getElementById('variable-name-input');
    this.titleEl = document.getElementById('variable-modal-title');
    this.labelEl = document.getElementById('variable-input-label');
    this.hintEl = document.getElementById('variable-modal-hint');
    this.iconEl = document.getElementById('variable-modal-icon');
    this.errorEl = document.getElementById('variable-modal-error');

    this.input.addEventListener('input', () => {
      this.clearError();
    });

    const closeBtn = document.getElementById('btn-close-variable-modal');
    const cancelBtn = document.getElementById('btn-cancel-variable');
    const saveBtn = document.getElementById('btn-save-variable');

    closeBtn.addEventListener('click', () => this.hide());
    cancelBtn.addEventListener('click', () => this.hide());

    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) {
        this.hide();
      }
    });

    saveBtn.addEventListener('click', () => this.handleSave());

    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.handleSave();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        this.hide();
      }
    });

    window.addEventListener('keydown', (e) => {
      if (this.overlay && this.overlay.classList.contains('active')) {
        if (e.key === 'Escape') {
          this.hide();
        }
      }
    });
  }

  show(config = {}) {
    this.currentType = config.type || 'variable';
    this.activeCallback = config.callback || null;

    if (this.currentType === 'list') {
      this.titleEl.textContent = config.title || 'Tạo Danh Sách Mới';
      this.labelEl.textContent = config.label || 'Tên danh sách mới:';
      this.input.placeholder = 'Ví dụ: danh_sach_mau, toa_do_diem...';
      this.hintEl.textContent = 'Danh sách chứa tập hợp nhiều phần tử dùng trong thuật toán robot.';
      this.iconEl.className = 'variable-modal-badge list-badge';
      this.iconEl.innerHTML = `
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="8" y1="6" x2="21" y2="6"/>
          <line x1="8" y1="12" x2="21" y2="12"/>
          <line x1="8" y1="18" x2="21" y2="18"/>
          <line x1="3" y1="6" x2="3.01" y2="6"/>
          <line x1="3" y1="12" x2="3.01" y2="12"/>
          <line x1="3" y1="18" x2="3.01" y2="18"/>
        </svg>
      `;
    } else {
      this.titleEl.textContent = config.title || 'Tạo Biến Số Mới';
      this.labelEl.textContent = config.label || 'Tên biến số mới:';
      this.input.placeholder = 'Ví dụ: diem_so, van_toc, buoc_dem...';
      this.hintEl.textContent = 'Biến số dùng chung cho toàn bộ kịch bản điều khiển robot.';
      this.iconEl.className = 'variable-modal-badge';
      this.iconEl.innerHTML = `
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M4 7V4h16v3M9 20h6M12 4v16"/>
        </svg>
      `;
    }

    this.clearError();
    this.input.value = config.defaultValue || '';
    this.overlay.classList.add('active');

    setTimeout(() => {
      this.input.focus();
      this.input.select();
    }, 100);
  }

  showError(message) {
    if (this.errorEl) {
      this.errorEl.textContent = message;
      this.errorEl.style.display = 'flex';
    }
    if (this.input) {
      this.input.style.borderColor = '#EF4444';
      this.input.focus();
    }
  }

  clearError() {
    if (this.errorEl) {
      this.errorEl.textContent = '';
      this.errorEl.style.display = 'none';
    }
    if (this.input) {
      this.input.style.borderColor = '';
    }
  }

  hide(wasSaved = false) {
    if (!wasSaved && this.activeCallback) {
      this.activeCallback(null);
      this.activeCallback = null;
    }
    if (this.overlay) {
      this.overlay.classList.remove('active');
    }
  }

  handleSave() {
    this.clearError();
    const rawVal = this.input.value ? this.input.value.trim() : '';
    if (!rawVal) {
      this.showError('Vui lòng nhập tên!');
      return;
    }

    const cb = this.activeCallback;
    if (cb) {
      const result = cb(rawVal);
      if (result === false) {
        return; // Validation failed, keep modal open
      }
      this.activeCallback = null;
    } else if (this.onConfirm) {
      const result = this.onConfirm(rawVal, this.currentType);
      if (result === false) {
        return; // Validation failed, keep modal open
      }
    }

    this.hide(true);
  }
}
